import solver from 'solver-utilities';
import { auth as api } from './shopify.js';
import { validation } from './validation.js';
import { info, success, error } from './notification.js';
import { TYPES } from './types.js';

let isValidFirstname = false;
let isValidLastname = false;
let isValidEmail = false;
let isValidPassword = false;
let isConfirmPassword = false;

const validate = function (event, field, form) {
	event.preventDefault();

	let btn = document.querySelector('main [data-btn="auth"]');
	const value = event.currentTarget.value;

	if (field == 'firstname') {
		if (validation.firstname(value)) {
			isValidFirstname = true;
		} else {
			isValidFirstname = false;
		}
	}

	if (field == 'lastname') {
		if (validation.lastname(value)) {
			isValidLastname = true;
		} else {
			isValidLastname = false;
		}
	}

	if (field == 'email') {
		if (validation.email(value)) {
			isValidEmail = true;
		} else {
			isValidEmail = false;
		}
	}

	if (field == 'password') {
		if (validation.password(value)) {
			isValidPassword = true;
		} else {
			isValidPassword = false;
		}
	}

	if (field == 'confirm') {
		if (validation.confirm(value)) {
			isConfirmPassword = true;
		} else {
			isConfirmPassword = false;
		}
	}

	if (form === 'signin') {
		if (isValidEmail && isValidPassword) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}
	if (form === 'register') {
		if (
			isValidFirstname &&
			isValidLastname &&
			isValidEmail &&
			isValidPassword &&
			isConfirmPassword
		) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}

	if (form === 'forgot') {
		if (isValidEmail && isValidPassword) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}

	if (form === 'reset-password') {
		if (isValidPassword && isConfirmPassword) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}

	if (form === 'active-account') {
		if (isValidPassword && isConfirmPassword) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}

	if (form === 'forgot-password') {
		btn = document.querySelector('main [data-form="forgot-password"] [data-btn="auth"]');
		if (isValidEmail) {
			btn.classList.remove('button--disabled');
		} else {
			btn.classList.add('button--disabled');
		}
	}
};

const open = function () {
	const delay = 10; // FIX ALL OF THESE
	const modal = document.querySelector('[data-el="auth-modal"]');
	const container = document.querySelector('[data-el="auth-container"]');
	const authbtn = document.querySelectorAll('[data-el="authButton"]');

	if (!modal || !authbtn) return;

	authbtn.forEach((btn) => {
		btn.addEventListener('click', async (event) => {
			event.preventDefault();

			modal.classList.add('auth-flyout--active');

			await solver.each.asyncTimeout(delay);
			document.body.style.overflow = 'hidden';

			modal.classList.add('animate__fadeIn');

			await solver.each.asyncTimeout(delay);

			container.classList.add('animate__slideInRight');
		});
	});
};

export const close = async function () {
	const delay = 10;
	const modal = document.querySelector('[data-el="auth-modal"]');
	const container = document.querySelector('[data-el="auth-container"]');

	container.classList.add('animate__slideOutRight');

	document.body.style.overflow = 'unset';

	await solver.each.asyncTimeout(delay);

	modal.classList.add('animate__fadeOut');

	await solver.each.asyncTimeout(delay);

	modal.classList.remove('auth-flyout--active', 'animate__fadeOut', 'animate__fadeIn');
	container.classList.remove('animate__slideOutRight', 'animate__slideInRight');
};

const toggle = async function (event, form) {
	if (event) event.preventDefault();

	if (form === 'forgot-password') {
		window.location.hash = '#recover';
	} else {
		window.location.hash = '';
	}

	const delay = parseInt(solver.frontend.getCSSVariable('--animate-delay'));
	const target = document.querySelector(`[data-form="${form}"]`);
	const forms = document.querySelectorAll('[data-form]');

	forms.forEach((_form) => _form.classList.add('animate__fadeOut'));
	await solver.each.asyncTimeout(delay);

	forms.forEach((_form) =>
		_form.classList.remove('container--active', 'animate__fadeOut', 'animate__fadeIn')
	);
	await solver.each.asyncTimeout(delay);

	target.classList.add('container--active');
	await solver.each.asyncTimeout(delay);
	target.classList.add('animate__fadeIn');
};

const display = function (event, state) {
	const passwords = document.querySelectorAll('input[name="customer[password]" ]');
	const confirms = document.querySelectorAll(
		'input[name="customer[confirm_password]" ], input[name="customer[password_confirmation]"]'
	);

	const toggles = {
		hide: document.querySelectorAll('[data-el="password-hide"]'),
		show: document.querySelectorAll('[data-el="password-show"]')
	};
	toggles.hide.forEach((el) => el.classList.remove('form__password-toggle--active'));
	toggles.show.forEach((el) => el.classList.remove('form__password-toggle--active'));

	toggles[state].forEach((el) => el.classList.add('form__password-toggle--active'));

	if (state == 'show') {
		passwords.forEach((el) => el.setAttribute('type', 'text'));
		confirms.forEach((el) => el.setAttribute('type', 'text'));
	} else {
		passwords.forEach((el) => el.setAttribute('type', 'password'));
		confirms.forEach((el) => el.setAttribute('type', 'password'));
	}
};

const activate = async function (event) {
	event.preventDefault();

	const _getParams = function () {
		const key = '/account/activate/';
		const pathname = window.location.pathname;

		if (pathname.indexOf(key) == -1) return null;

		const arr = pathname.split(key);
		if (arr.length != 2) return;

		const params = arr[1].split('/');
		if (params.length != 2) return null;

		return {
			id: params[0],
			token: params[1]
		};
	};

	const params = _getParams();

	if (!params) return;

	const data = new FormData();
	const form = event.target;
	const inputs = form.querySelectorAll('input[type="text"], input[type="password"]');
	data.append('form_type', 'activate_customer_password');
	data.append('id', params.id);
	data.append('token', params.token);

	inputs.forEach((input) => {
		if (input) data.append(input.name, input.value);
	});

	const req = await api.activate(data);

	if (!req.data) {
		error(TYPES.AUTH.ACTIVATE.ERROR);
		return;
	}

	success(TYPES.AUTH.ACTIVATE.SUCCESS);

	await solver.frontend.asyncTimeout(3000);

	window.location.href = '/account/login';
};

const register = async function (event) {
	event.preventDefault();

	const data = new FormData();
	const form = event.target;
	const inputs = form.querySelectorAll(
		'input[type="text"], input[type="email"], input[type="password"]'
	);
	data.append('form_type', 'create_customer');

	inputs.forEach((input) => {
		if (input) data.append(input.name, input.value);
	});

	const req = await api.register(data);

	if (!req.data) {
		error(TYPES.AUTH.REGISTER.ERROR);
		return;
	}

	success(TYPES.AUTH.REGISTER.SUCCESS);

	await solver.frontend.asyncTimeout(3000);

	window.location.href = '/account/login';
};

const login = async function (event) {
	event.preventDefault();

	const data = new FormData();
	const form = event.target;
	const inputs = form.querySelectorAll(
		'input[type="text"], input[type="email"], input[type="password"]'
	);

	data.append('form_type', 'customer_login');

	inputs.forEach((input) => {
		if (input) data.append(input.name, input.value);
	});

	const req = await api.register(data);

	if (!req.data) {
		error(TYPES.AUTH.REGISTER.ERROR);
		return;
	}

	window.location.href = '/account';
};

const recover = async function (event) {
	event.preventDefault();

	const data = new FormData();
	const form = event.target;
	const inputs = form.querySelectorAll('input[type="email"]');

	data.append('form_type', 'recover_customer_password');
	inputs.forEach((input) => {
		if (input) data.append(input.name, input.value);
	});

	const req = await api.recover(data);

	success(TYPES.AUTH.RECOVER.GENERAL);

	await solver.frontend.asyncTimeout(3000);

	window.location.href = '/account/login';
};

const reset = async function (event) {
	event.preventDefault();

	const _getParams = function () {
		const key = '/account/reset/';
		const pathname = window.location.pathname;

		if (pathname.indexOf(key) == -1) return null;

		const arr = pathname.split(key);
		if (arr.length != 2) return;

		const params = arr[1].split('/');
		if (params.length != 2) return null;

		return {
			id: params[0],
			token: params[1]
		};
	};

	const params = _getParams();

	if (!params) return;

	const data = new FormData();
	const form = event.target;
	const inputs = form.querySelectorAll('input[type="password"]');

	data.append('form_type', 'reset_customer_password');
	data.append('id', params.id);
	data.append('token', params.token);
	inputs.forEach((input) => {
		if (input) data.append(input.name, input.value);
	});

	const req = await api.reset(data);

	if (!req.data) {
		error(TYPES.AUTH.RESET.ERROR);
		return;
	}

	success(TYPES.AUTH.RESET.SUCCESS);

	await solver.frontend.asyncTimeout(3000);

	window.location.href = '/account/login';
};

export const auth = function () {
	open();
	window.Solver.validate = validate;
	window.Solver.authClose = close;
	window.Solver.toggleForm = toggle;
	window.Solver.togglePassword = display;
	window.Solver.accountRegister = register;
	window.Solver.accountLogin = login;
	window.Solver.accountRecover = recover;
	window.Solver.accountActivate = activate;
	window.Solver.accountReset = reset;
};
